export function ComponentGrid() {
  $('.grid-item .button-close').on('click', function (e) {
    e.preventDefault();
  });

  $('.grid-item').on('click', function () {
    var gridItem = $(this);

    if (gridItem.hasClass('grid-item-large')) {
      gridItem.removeClass('grid-item-large');
      $('.grid-item .content').removeClass('active');
    } else {
      var ghost = gridItem.find('.grid-item-content').clone();
      ghost.removeClass('w-100 h-100').css({
        top: gridItem.offset().top,
        left: gridItem.offset().left,
        width: gridItem.width(),
        height: gridItem.height()
      });

      $('body').append(ghost);

      $('.grid-item').removeClass('grid-item-large');
      $('.grid-item .content').removeClass('active');
      gridItem.addClass('grid-item-large grid-item-enlarging');

      setTimeout(function () {
        ghost.css({
          top: gridItem.offset().top,
          left: gridItem.offset().left,
          width: gridItem.width(),
          height: gridItem.height()
        });
      }, 10);

      setTimeout(function () {
        gridItem.removeClass('grid-item-enlarging');
        gridItem.find('.content').addClass('active');
        ghost.fadeOut();
      }, 520);
    }
  });
}
